/**
 * Base web component helpers
 */
window.AlverioComponent = class AlverioComponent extends HTMLElement {
  connectedCallback() {
    if (typeof this.init === 'function') this.init();
  }

  disconnectedCallback() {
    if (typeof this.destroy === 'function') this.destroy();
  }

  $(selector) {
    return this.querySelector(selector);
  }

  $$(selector) {
    return this.querySelectorAll(selector);
  }
};
